import isEmpty from 'lodash/isEmpty';

// The number we submit to Attentive has to follow e164 format. This function
// removes any non-numeric characters and prepends a '1' if the number doesn't
// already include it. If the number is invalid, an error is thrown.
// This function is only valid for US phone numbers currently.
export function fixPhoneNumberFormat(
  phoneNumber: string | null,
  confirm: boolean
) {
  if (confirm) {
    if (isEmpty(phoneNumber)) {
      throw new Error('Phone number is required');
    }
    // @ts-ignore
    let possiblePhoneNumber = phoneNumber.replace(/[^0-9]/g, '');
    if (!possiblePhoneNumber.startsWith('1')) {
      possiblePhoneNumber = `1${possiblePhoneNumber}`;
    }

    if (!possiblePhoneNumber.match('^1[2-9][0-9]{9}$')) {
      throw new Error('Invalid phone number format');
    }
    return possiblePhoneNumber;
  }
  return phoneNumber;
}

// this function formats a phone number into a more readable format for
// display in the UI. It is only valid for US phone numbers currently.
export function formatPhoneNumberForDisplay(phoneNumberString: string) {
  const cleaned = `${phoneNumberString}`.replace(/\D/g, '');
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? '1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return phoneNumberString;
}
